import { serviceTone, type Service } from '@/design-system';

import { planningCopy } from '../copy';

export interface ServiceLegendProps {
    /** De dienstkleuren die dit bedrijf nodig heeft, zie `legendServices`. */
    services: readonly Service[];
}

/**
 * De dienstkleuren van dit bedrijf, uitgeschreven. Kleur draagt nooit alleen betekenis.
 *
 * Alleen wat het bedrijf levert of wat in beeld staat: een kleur voor een dienst die het
 * bedrijf niet heeft, zou die dienst aanprijzen.
 */
export function ServiceLegend({ services }: ServiceLegendProps) {
    if (services.length === 0) {
        return null;
    }

    return (
        <ul
            aria-label={planningCopy.legendLabel}
            className="m-0 mt-[14px] flex list-none flex-wrap gap-[18px] p-0 text-[12px] text-[var(--text-tertiary-safe)]"
        >
            {services.map((service) => (
                <li key={service} className="flex items-center gap-[7px]">
                    <span
                        aria-hidden="true"
                        className="h-[10px] w-[10px] rounded-[3px]"
                        style={{ background: serviceTone[service].bar }}
                    />
                    {serviceTone[service].label}
                </li>
            ))}
        </ul>
    );
}
